import React, { useEffect, useState, useRef } from 'react'
import './VideoSplash.css'
import videoSrc from '../../assets/video/bk_optimized.mp4'
import lastFrameImg from '../../assets/img/last_frame.png'

const VideoSplash = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true)
  const [showImage, setShowImage] = useState(false)
  const videoRef = useRef(null)

  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    const handleEnded = () => {
      setShowImage(true)
      setTimeout(() => {
        setIsVisible(false)
        if (onComplete) {
          onComplete()
        }
      }, 800)
    }

    const handleError = () => {
      console.warn('Video splash failed to load')
      setIsVisible(false)
      if (onComplete) {
        onComplete()
      }
    }

    video.addEventListener('ended', handleEnded)
    video.addEventListener('error', handleError)

    video.play().catch((error) => {
      console.warn('Autoplay was prevented:', error)
      setShowImage(true)
      setTimeout(() => {
        setIsVisible(false)
        if (onComplete) {
          onComplete()
        }
      }, 1500)
    })

    return () => {
      video.removeEventListener('ended', handleEnded)
      video.removeEventListener('error', handleError)
    }
  }, [onComplete])

  if (!isVisible) {
    return null
  }

  return (
    <div className="v4-video-splash">
      <video
        ref={videoRef}
        className="v4-video-splash-video"
        muted
        playsInline
        preload="auto"
        poster=""
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      {showImage && (
        <img 
          src={lastFrameImg} 
          alt="Background" 
          className="v4-video-splash-image"
        />
      )}
    </div>
  )
}

export default VideoSplash

